const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function stringifiedReturnByDate(returnByDate) {
  return `${
    MONTH_NAMES[returnByDate.getMonth()]
  } ${returnByDate.getDate()}, ${returnByDate.getFullYear()}`;
}

export function findKeyInNestedStructure(data, targetKey) {
  function traverse(obj) {
    if (Array.isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        const result = traverse(obj[i]);
        if (result) {
          return result;
        }
      }
    }

    if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (key === targetKey) {
          return obj[key];
        }
        const result = traverse(obj[key]);
        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  return traverse(data);
}
